import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

/**
 * FitBounds Component (Internal)
 * Automatically adjusts the map viewport to contain all provided markers.
 * 
 * @param {Object} props
 * @param {Array} props.markers - Array of [lat, lng] coordinates
 */
function FitBounds({ markers }) {
    const map = useMap();
    useEffect(() => {
        if (markers && markers.length > 0) {
            const valid = markers.filter(m => m && m[0] && m[1]);
            if (valid.length > 0) {
                const bounds = L.latLngBounds(valid);
                map.fitBounds(bounds, { padding: [50, 50], maxZoom: 15 });
            }
        }
    }, [markers, map]);
    return null;
}

/**
 * AssignmentMap Component
 * Displays a mini map with markers for the start, destination, and return locations of an assignment.
 * 
 * @component
 * @param {Object} props
 * @param {Object} props.form - Current form state containing location coordinates
 * @param {boolean} props.customReturn - Whether a different return location is specified
 */
const AssignmentMap = ({ form, customReturn }) => {
    return (
        <div className="route-map-mini">
            <MapContainer center={[51.16, 10.45]} zoom={6} style={{ height: '200px', width: '100%', zIndex: 1 }}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                {form.route_from_lat && <Marker position={[form.route_from_lat, form.route_from_lng]} />}
                {form.route_to_lat && <Marker position={[form.route_to_lat, form.route_to_lng]} />}
                {customReturn && form.route_return_lat && <Marker position={[form.route_return_lat, form.route_return_lng]} />}
                <FitBounds markers={[
                    [form.route_from_lat, form.route_from_lng],
                    [form.route_to_lat, form.route_to_lng],
                    customReturn ? [form.route_return_lat, form.route_return_lng] : null
                ]} />
            </MapContainer>
        </div>
    );
};

export default AssignmentMap;
